// extracted by mini-css-extract-plugin
export default {"wrapper":"TrailDetails_wrapper__cOtBV"};